module.exports = __webpack_public_path__ + "img/demo-waitlist-calculator.28b6b1ad.png";